export const environment = {
  //https://rhapp-homol.gftecnologia.dev.br
  
  production: false,
  apiUrl: 'https://api-homol.rhapp.com.br',
  URL_IO:  'wss://api-homol.rhapp.com.br'
};
